import { useDispatch, useSelector } from '@redux';
import RestEdit from 'containers/rest/Edit';
import { DynamicObjectType } from 'types/commons';
import { DeleteButton } from 'components/commons/ButtonOptions/DeleteButton';
import { useRef, useState } from 'react';
import DelModal from 'components/commons/ModalCustom/DelModal';
import LocationForm from '../components/LocationForm';
import crudActions from '@redux/crudActions';
import { useNavigate } from 'react-router-dom';
import { Modal, notification } from 'antd';
import I18n from 'i18next';
import { calStockApi } from 'api/crud';

export default function LocationEdit() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deleteLocationRef = useRef<{ open: () => void }>();
  const locationsCurr = useSelector(
    (state) => state.locations.currentData,
  ) as DynamicObjectType;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const breadcrumbs = [
    {
      title: 'common.page.settings',
      href: '/settings',
    },
    {
      title: 'common.page.locations',
      href: '/settings/warehouse-locations',
    },
    {
      title: `#${locationsCurr?.id}`,
    },
  ];

  const customActionEdit = (values) => {
    setIsModalOpen(true);
    Promise.all([
      dispatch(
        crudActions['locations'].edit({
          data: {
            ...values,
            lat: parseFloat(values?.lat),
            long: parseFloat(values?.long),
          },
          options: {
            isShowSuccessNoti: false,
          },
        }),
      ),
      calStockApi(),
    ])
      .then(() => {
        notification.success({
          message: I18n.t('common.success.title'),
          description: I18n.t('common.success.description'),
        });
        navigate('/settings/warehouse-locations');
      })
      .catch((error) => {
        notification.error({
          message: I18n.t('common.error.title'),
          description:
            JSON.stringify(error?.message) || I18n.t('error.description'),
        });
      })
      .finally(() => {
        setIsModalOpen(false);
      });
  };

  return (
    <>
      <RestEdit
        model="locations"
        breadcrumbs={breadcrumbs}
        customUrlBack="/settings/warehouse-locations"
        apiOptions={{
          suffix: '?join=detail&join=locationRelated',
          isRequestApi: true,
        }}
        options={[
          <DeleteButton
            handleDelete={() => deleteLocationRef.current.open()}
          />,
        ]}
        customActionEdit={customActionEdit}
      >
        <LocationForm />
      </RestEdit>
      <DelModal
        modal="locations"
        title="Location"
        // customDesc={t('productCategories.deleteDesc')}
        ref={deleteLocationRef}
      />
      <Modal
        title=""
        open={isModalOpen}
        keyboard={false}
        maskClosable={false}
        footer={null}
        closable={false}
      >
        <p className="text-[16px]">
          {I18n.t('settings.warehouseLocation.contentModalEdit')}
        </p>
      </Modal>
    </>
  );
}
